<template>
    <section class="font-poppins md:text-sm">
        <div class="flex text-blue-700">
            <i class="fa fa-line-chart"></i>
            <p class="ml-3 font-semibold">Inflow Data</p>
        </div>

        <div v-for="trans in transactions" :key="trans.id" class="bg-gray-100 p-2 rounded">
            <div class="flex justify-between bg-white p-2 rounded">
                <div class="flex">
                    <img class="bg-gray-200 rounded w-6 h-6 p-1" src="../../assets/analyt-icon.svg" alt="analyt">
                    <div>
                        <p class="ml-2">{{moment(trans.dateCreated).format("dddd")}}</p>
                        <p class="ml-2 text-xs">{{moment(trans.dateCreated).format("h:mma")}}</p>
                    </div>
                    
                </div>
                <div>
                    <div class="text-blue-700 font-semibold">
                        <sup>NGN </sup>
                        <span class="text-xl">{{trans.amount.toLocaleString()}}</span>
                    </div>
                </div>
            </div>           
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            transactions : [],
            userId: localStorage.getItem("userId"),
            token: localStorage.getItem("token"),
        }
    },

    mounted() {
        this.getTransaction();
    },
    methods: {
         moment(date) {
            return moment(date);
        },
        getTransaction() {
            axios({
              method: 'GET',
              url: `${url}/v1/web/transactions/${this.userId}`,
              headers: {
                  'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                  'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
              },
          })
          .then((res) =>{
              let info = res.data.data.results;
              this.transactions = info.slice(-1, -5);
          })
          .catch((err) =>{
              err.json
          })
        }
    }
}
</script>